var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 5.125H3.33333C2.71449 5.125 2.121 5.41473 1.68342 5.93046C1.24583 6.44618 1 7.14565 1 7.875V20.25C1 20.9793 1.24583 21.6788 1.68342 22.1945C2.121 22.7103 2.71449 23 3.33333 23H19.6667C20.2855 23 20.879 22.7103 21.3166 22.1945C21.7542 21.6788 22 20.9793 22 20.25V7.875C22 7.14565 21.7542 6.44618 21.3166 5.93046C20.879 5.41473 20.2855 5.125 19.6667 5.125H16.1667M15 10.625L11.5 14.75M11.5 14.75L8 10.625M11.5 14.75V1",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5a766ec31c657195330c5a712e1958eb.svg";
export { ForwardRef as ReactComponent };